import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsGetAll } from 'services/WService';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Fecha', accessor: 'created_at', width: 120 },
  { Header: 'Usuario', accessor: 'user' },
  { Header: 'Vendedor que solicita', accessor: 'SlpName' },
  { Header: 'Comentario', accessor: 'comment', width: 140 },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 130 },
  { Header: 'Nombre Cliente', accessor: 'CardName' },
  { Header: 'DNI / RUC', accessor: 'LicTradNum', width: 145 },
  { Header: 'Total de orden', accessor: 'total_order' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ClientesReactivados() {
  const [loading, setLoading] = useState([]);
  const [logs, setLogs] = useState([]);
  const [filters, setFilters] = useState({});

  async function getLogs() {
    const params = new URLSearchParams();
    params.append('start_date', filters.start_date);
    params.append('end_date', filters.end_date);
    setLogs([]);
    setLoading(true);
    let res = await wsGetAll(`base/business-partner/clientes-reactivados?${params.toString()}`);
    setLoading(false);
    if (res.success) setLogs(res.data);
  }

  useEffect(() => {
    if (Object.keys(filters).length === 0) return;
    getLogs();
  }, [filters]);

  return (
    <CardContainer title="Clientes Reactivados">
      <FilterCustom
        dateRange
        getFilter={setFilters}
        customControl={<>{loading && <LoadingSpinner />}</>}
      />
      <ReactTable
        excelName="Consulta-clientes-reactivados"
        defaultWidth={1000}
        formatDate="DD-MM-YYYY"
        columns={columns}
        data={logs.map((item, i) => {
          return {
            num: i + 1,
            created_at: item.created_at,
            user: item.created_by?.name || '-',
            SlpName: item.seller?.SlpName || '-',
            comment: item.comment ,
            CardCode: item.business_partner?.CardCode || '-',
            CardName: item.business_partner?.CardName || '-',
            LicTradNum: item.business_partner?.LicTradNum || '-',
            total_order: parseFloat(item.total_order).toFixed(2),
            actions: '',
          };
        })}
      />
    </CardContainer>
  );
}

export default ClientesReactivados;
